
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/series/letter/[letterSign]",
      function () {
        return require("private-next-pages/series/letter/[letterSign]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/series/letter/[letterSign]"])
      });
    }
  